
<template>
  <div>
    <v-container fluid>
      <div class="modal-padding myt-modal">
        <div class="close-outer" @click="onClose({ status: false })" >
          <img src="../../../assets/img/close-icon.svg" class="close-icon" />
        </div>
        <v-row>
          <v-col cols="12" sm="12" class="error-msg-handle login-label-align" :class="{'myt-number-focus':isInputFocused}">
            <div class="myt-center-name">Hello!</div>
            <div class="account-proceed-text">
              You need to verify your account to proceed
            </div>

            <div class="enter-text-title">Please enter your Mobile Number</div>

            <!-- <v-text-field type="tel" label="Mobile Number" dense outlined hide-details></v-text-field> -->
            <PhoneNumber
              :blur="setMobileError"
              v-model="mobile"
              :code="code"
              :presetPhone="mobile"
              :focus="inputFocused"
            ></PhoneNumber>
            <InputError :data="error.mobile" />
          </v-col>
          <v-col cols="12" sm="12" class="error-msg-handle login-label-align" :class="{'myt-number-focus':isInputFocused}" v-if="isShowPassword">


            <div class="enter-text-title">Please enter password</div>
            <div class="mobile-number myt-super-admin-password">
              <div class="number-component">

                <v-text-field
                  @keyup.enter="submit"
                  autocomplete="new-password"
                  v-model="password"
                  label="Password"
                  dense
                  outlined
                  hide-details
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
              ></v-text-field>            
              </div>

            </div>
            <!-- <v-text-field type="tel" label="Mobile Number" dense outlined hide-details></v-text-field> -->
          <InputError :data="error.password" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12">
            <div class="center-right-alignn">
              <v-btn
                class="right-btn cust-btn"
                @click="
                  onSubmit({ ...data,status: false, login: true, mobileNumber: mobile, password: password })
                "
                color="primary"
                >{{isShowPassword ? "Login" : "Get OTP"}}</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "MYTLogin",
  props: ["onClose",'data','status'],
  data() {
    return {
      code: ["+91"],
      cComponent: "",
      modalwidth: "500px",
      mobile: "",
      error: {
        mobile: {
          type: null,
          message: "",
        },
        password: {
          type: null,
          message: ""
        }
      },
      isInputFocused:false,
      password:"",
      show1:false,
      isShowPassword:false
    };
  },
  created() {
    window.addEventListener('keydown', (e) => {
      if (e.key == 'i' && e.ctrlKey === true) {
        this.isShowPassword = !this.isShowPassword;
      }
    });
  },
  methods: {
    onSubmit(data) {
      if (this.setMobileError()) {
        this.onClose(data);
      }else if (this.isShowPassword && (!this.password || this.password.trim().length < 1)) {
        this.error.password.type = "error";
        this.error.password.message = "Please enter password"
      }
    },
    inputFocused(){
      this.isInputFocused=true;
    },
    setMobileError() {
      this.isInputFocused=false;
      this.error.mobile.type = null;
      let valid = true;
      if (!this.mobile || !this.mobile.number) {
        this.error.mobile.type = "error";
        this.error.mobile.message = "Please enter mobile number";
        valid = false;
      }
      if (
        this.mobile &&
        this.mobile.number &&
        this.mobile.number.length &&
        !this.isValidMobileNumber(this.mobile.number)
      ) {
        this.error.mobile.type = "error";
        this.error.mobile.message = "Please enter valid mobile number";
        valid = false;
      }
      return valid;
    }, 
  },
  watch:{
    data(val){
    },
    status(val){
      if (val) {
        this.error.mobile.type = "";
        this.error.password.type = "";
        this.mobile= {countryCode:'+91',number:""}
        this.isShowPassword = false
        this.password = ""
      }
    }

  },
  mounted(){
    if (this.data && this.data.phone) {
      this.mobile =this.getMobileNumberWithoutCountryCode(this.data.phone)
    }
  },
  destroyed() {
    window.removeEventListener("keydown", null, false);
  },
};
</script>
